import animations from './animations'
import colors, { themeColors } from './colors'

const theme = { colors, animations }

export type ThemeName = keyof typeof themeColors

const wrapTheme = (name: ThemeName) => ({
	...theme,
	colors: {
		...theme.colors,
		selectedTheme: themeColors[name],
	},
})

export type ThemeInterface = ReturnType<typeof wrapTheme>

export const themes = {
	dark: wrapTheme('dark'),
	snx: wrapTheme('snx'),
}
